import React, { useState } from "react";
import Invite from "../Invite/Invite";
import Avatar from "react-initials-avatar";
import { FaPlus } from "react-icons/fa";
import useTitanApp from "../../hooks/useTitanApp";
import { Tooltip } from "@mui/material";
import { setShowInviteModal,setShowSettingsModal,setSettingsActiveTab } from "../../dispatchers/appDispatchers";
import { useSettingsTabSwitcher } from "@/lib/settingsData";

export default function TeamMembers() {
  const { appState } = useTitanApp();
  const { headerTeamMembers = [], showInviteModal } = appState || {};
  const { switchTabWithData } = useSettingsTabSwitcher();

  const teamMemberstoShow = headerTeamMembers.slice(0, 4);
  const teamMemberstoHide = headerTeamMembers.slice(4);   
    const handleInviteClick = async () => {
    setSettingsActiveTab("members"); 
    setShowSettingsModal(true); 
    await switchTabWithData("members");
  };
  return (  
    <div className="team-members">
      {teamMemberstoShow?.length > 0 ? (
        teamMemberstoShow?.map((teamMember, index) => (
          <div key={index} className="team-img-text">
            <Tooltip title={teamMember?.userFirstName} arrow>
              <div className="team-img label-btn">
                {teamMember?.teamMemberImage ? (
                  <img src={teamMember?.teamMemberImage} />
                ) : (
                  <Avatar
                    name={teamMember?.userFirstName}
                    size={40}
                    fontSize={18}
                  />
                )}
              </div>
            </Tooltip>
          </div>
        ))
      ) : (
        <div className="team-img-text">
          {headerTeamMembers?.map((member, index) => (
            <Tooltip key={index} title={member?.userFirstName} arrow>
              <div className="team-img label-btn">
                {member?.teamMemberImage ? (
                  <img
                    src={member?.teamMemberImage}
                    alt={member?.userFirstName}
                  />
                ) : (
                  <Avatar
                    name={member?.userFirstName}
                    size={40}
                    fontSize={18}
                  />
                )}
              </div>
            </Tooltip>
          ))}
        </div>
      )}

      {teamMemberstoHide?.length > 0 ? (
        <div className="team-member-count">
          <Tooltip title={teamMemberstoHide?.length + "+ others"} arrow>
            <div className="team-length label-btn">
              <p>{teamMemberstoHide?.length}</p>
            </div>
          </Tooltip>
        </div>
      ) : (
        <></>
      )}
      <Tooltip title="Invite team member" arrow>
          <div
          className="team-member-add"
          onClick={handleInviteClick}
        >
          <div className="team-add label-btn">
            <FaPlus className="para_color" size={12} />
          </div>
        </div>
      </Tooltip>
    </div>
  );
}
